import { render, staticRenderFns } from "./buildingProperties.vue?vue&type=template&id=1ce505dc&scoped=true&"
import script from "./buildingProperties.vue?vue&type=script&lang=js&"
export * from "./buildingProperties.vue?vue&type=script&lang=js&"
import style0 from "./buildingProperties.vue?vue&type=style&index=0&id=1ce505dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce505dc",
  null
  
)

export default component.exports